import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
// Stylesheets
import './styles.css';
import './styles-marketing.css';

// Register service worker for PWA (production only). In dev, actively unregister any SW.
if (!import.meta.env.PROD && 'serviceWorker' in navigator) {
  // Dev mode: ensure no service worker controls the page
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
  // Best-effort clear app caches in dev
  if ('caches' in window) {
    caches.keys().then(keys => keys.forEach(k => {
      if (k.startsWith('dailey-') || k.startsWith('crispy-')) {
        caches.delete(k);
      }
    }));
  }
}

// Register media cache service worker for instant image loading (production only)
// This SW intercepts /media/variants/* requests and serves from CacheStorage
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-media-cache.js')
      .then(registration => {
        console.log('[MediaCache] Service worker registered:', registration.scope);
      })
      .catch(error => {
        console.warn('[MediaCache] Service worker registration failed:', error);
      });
  });
}

// Staging safety: only register the full PWA service worker when explicitly enabled.
if (import.meta.env.PROD && import.meta.env.VITE_ENABLE_SW === 'true' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registered:', registration);
      })
      .catch(error => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}

createRoot(document.getElementById('root')).render(
  <App />
);
